// src/services/api.ts
import axios from 'axios';
import { getLanguageId, getToken } from '../utils/token';

const api = axios.create({
    baseURL: 'https://mobilhastanem.com/Api/',
    //baseURL: 'https://mobilhastanemtest.mlpcare.com/Api/',
});

api.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers.LanguageId = getLanguageId();

    return config;
});




export default api;
